import React, { useState, useEffect } from 'react';

/**
 * Chọn ngày sinh / ngày tham gia bằng 3 dropdown Ngày — Tháng — Năm (thứ tự đọc của người Việt).
 * Lý do KHÔNG dùng <input type="date">: muốn chọn năm xa (vd 1983) phải bấm lùi rất nhiều lần.
 * Dropdown Năm cho nhảy thẳng tới năm cần → tiện nhất cho người Việt điền ngày sinh.
 *
 * value: chuỗi 'YYYY-MM-DD' (hoặc '' nếu chưa đủ). onChange nhận 'YYYY-MM-DD' khi đủ 3 phần, '' nếu thiếu.
 */
const pad = (n) => String(n).padStart(2, '0');
const range = (from, to) => { const a = []; for (let i = from; i <= to; i++) a.push(i); return a; };

const DateSelect = ({ value, onChange, yearFrom, yearTo, disabled }) => {
  const init = (value || '').split('-');
  const [yy, setYy] = useState(init[0] || '');
  const [mm, setMm] = useState(init[1] ? String(Number(init[1])) : '');
  const [dd, setDd] = useState(init[2] ? String(Number(init[2])) : '');

  // Đồng bộ khi value đầy đủ đổi từ bên ngoài (vd update mode đổ sẵn hồ sơ). Bỏ qua value rỗng
  // để không xoá lựa chọn dở dang của user (chọn ngày trước, chưa chọn năm).
  useEffect(() => {
    if (value && value.length >= 8) {
      const p = value.split('-');
      setYy(p[0]); setMm(String(Number(p[1]))); setDd(String(Number(p[2])));
    }
  }, [value]);

  const emit = (nd, nm, ny) => onChange(nd && nm && ny ? `${ny}-${pad(nm)}-${pad(nd)}` : '');

  const cls = `px-2 py-3 rounded-xl border text-[16px] bg-gray-50 border-gray-200 focus:ring-2 focus:ring-brand-500 outline-none ${disabled ? 'opacity-60' : ''}`;
  const years = range(yearFrom, yearTo).reverse(); // mới → cũ (gần đây ở trên)

  return (
    <div className="grid grid-cols-3 gap-2">
      <select disabled={disabled} className={cls} value={dd} onChange={(e) => { setDd(e.target.value); emit(e.target.value, mm, yy); }}>
        <option value="">Ngày</option>
        {range(1, 31).map((n) => <option key={n} value={n}>{n}</option>)}
      </select>
      <select disabled={disabled} className={cls} value={mm} onChange={(e) => { setMm(e.target.value); emit(dd, e.target.value, yy); }}>
        <option value="">Tháng</option>
        {range(1, 12).map((n) => <option key={n} value={n}>Tháng {n}</option>)}
      </select>
      <select disabled={disabled} className={cls} value={yy} onChange={(e) => { setYy(e.target.value); emit(dd, mm, e.target.value); }}>
        <option value="">Năm</option>
        {years.map((n) => <option key={n} value={n}>{n}</option>)}
      </select>
    </div>
  );
};

export default DateSelect;
